import React, { useContext, useState, useEffect } from 'react'

import { useSelector } from 'react-redux'
import { callFunctionIfDefined } from '../../../../utils/functionHelper'
import Selector from '../../Selectors/Selector'
import InternshipCard from './InternshipCard'
import { getSectionAbbreviation, isObject } from '../../../../utils'
import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { InstitutionContext } from '../../../../Providers/InstitutionProvider'

const NO_INTERNSHIP_YEAR_TEXT = 'Without internship year'

const ActionInternshipCard = ({ displaySectorSelector, internship, tooltip, onUpdate }) => {
  const ic = useContext(InstitutionContext)

  const t = useSelector(selectTranslate)

  const [textualData, setTextualData] = useState({})

  useEffect(() => {
    if (internship && typeof t === 'function') {
      setTextualData({
        internshipYear: internship.internshipYear ? internship.internshipYear.schoolYearName : t(NO_INTERNSHIP_YEAR_TEXT),
        section: getSectionAbbreviation(internship.section, t)
      })
    }
  }, [internship, t])

  const handleSectorSelected = (id, sector) => {
    callFunctionIfDefined(onUpdate, [sector])
  }

  return (
    <div className='internship-info-old'>
      <InternshipCard
        displaySector={!displaySectorSelector}
        internship={internship}
        legend={tooltip && 'internship_request_card.legend'}
      />
      {displaySectorSelector && (
        <div className='flex-row' style={{ height: '25px', lineHeight: '25px' }}>
          {textualData.section} - {textualData.internshipYear} -
          <Selector
            data={isObject(ic) ? ic.sectorsOrderByName : []}
            dataKey='name'
            onSelect={handleSectorSelected}
            showArrow={false}
            showEmpty
            showSearch
            value={!internship.sector || internship.sector.parent === null ? -1 : internship.sector.id}
          />
        </div>
      )}
    </div>
  )
}

export default ActionInternshipCard
